import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { duration: { type: Number, default: 4000 } }

  connect() {
    // Slide in
    requestAnimationFrame(() => {
      this.element.classList.remove("translate-y-2", "opacity-0")
      this.element.classList.add("translate-y-0", "opacity-100")
    })

    // Auto-dismiss
    this.timeout = setTimeout(() => this.dismiss(), this.durationValue)
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout)
  }

  dismiss() {
    this.element.classList.remove("translate-y-0", "opacity-100")
    this.element.classList.add("-translate-y-2", "opacity-0")
    setTimeout(() => this.element.remove(), 300)
  }
}
